"use client";

import React, { useState } from "react";
import styled from "styled-components";
import Text from "../../Text";
import type { EditableCellType } from "./EditableTableCell";

const BulkInput = styled.input`
  flex: 1;
  font-size: inherit;
  line-height: 1.4;
  padding: 4px 0;
  outline: none;
  background: transparent;
  font-family: inherit;
  color: #111;
`;

type Props = {
  type: EditableCellType;
  onCommit: (value: string) => void;
  currencySymbol?: string;
};

const BulkInputCell: React.FC<Props> = ({ type, onCommit, currencySymbol = "$" }) => {
  const [textValue, setTextValue] = useState(""),
    isNumeric = type === "number" || type === "percent" || type === "currency",
    inputType = isNumeric ? "number" : type === "date" || type === "datetime-local" ? type : "text";

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onCommit(textValue);
      setTextValue("");
    } else if (e.key === "Escape") {
      setTextValue("");
    }
  };

  return (
    <>
      {type === "currency" && (
        <Text style={{ fontSize: "inherit", color: "#666", flexShrink: 0 }}>{currencySymbol}</Text>
      )}
      <BulkInput
        type={inputType}
        step={type === "currency" ? "0.01" : undefined}
        min={type === "currency" ? "0" : undefined}
        value={textValue}
        onChange={e => setTextValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={type === "date" || type === "datetime-local" ? undefined : "Bulk edit…"}
      />
      {type === "percent" && (
        <Text style={{ fontSize: "inherit", color: "#666", flexShrink: 0 }}>%</Text>
      )}
    </>
  );
};

export default BulkInputCell;
